import BigNumber from 'bignumber.js';
import { DocumentBuilderForm } from '~/types/document-builder';
import { DatiCassaPrevidenziale, TipoCassa, VatTotal } from '~/types/invoicing';

export const socialSecurityTypeOptions = [
  {
    value: TipoCassa.AvvocatiEProcuratori,
    label: 'Cassa nazionale previdenza e assistenza avvocati e procuratori legali',
  },
  { value: TipoCassa.Commercialisti, label: 'Cassa previdenza dottori commercialisti' },
  { value: TipoCassa.Geometri, label: 'Cassa previdenza e assistenza geometri' },
  {
    value: TipoCassa.IngegneriArchitetto,
    label: 'Cassa nazionale previdenza e assistenza ingegneri e architetti liberi professionisti',
  },
  { value: TipoCassa.Notariato, label: 'Cassa nazionale del notariato' },
  {
    value: TipoCassa.RagioneriPeriti,
    label: 'Cassa nazionale previdenza e assistenza ragionieri e periti commerciali',
  },
  { value: TipoCassa.ENASARCO, label: 'Ente nazionale assistenza agenti e rappresentanti di commercio (ENASARCO)' },
  { value: TipoCassa.ENPACL, label: 'Ente nazionale previdenza e assistenza consulenti del lavoro (ENPACL)' },
  { value: TipoCassa.ENPAM, label: 'Ente nazionale previdenza e assistenza medici (ENPAM)' },
  { value: TipoCassa.ENPAF, label: 'Ente nazionale previdenza e assistenza farmacisti (ENPAF)' },
  { value: TipoCassa.ENPAV, label: 'Ente nazionale previdenza e assistenza veterinari (ENPAV)' },
  { value: TipoCassa.ENPAIA, label: "Ente nazionale previdenza e assistenza impiegati dell'agricoltura (ENPAIA)" },
  { value: TipoCassa.Marittime, label: 'Fondo previdenza impiegati imprese di spedizione e agenzie marittime' },
  { value: TipoCassa.INPGI, label: 'Istituto nazionale previdenza giornalisti italiani (INPGI)' },
  { value: TipoCassa.ONAOSI, label: 'Opera nazionale assistenza orfani sanitari italiani (ONAOSI)' },
  { value: TipoCassa.CASAGIT, label: 'Cassa autonoma assistenza integrativa giornalisti italiani (CASAGIT)' },
  { value: TipoCassa.EEPI, label: 'Ente previdenza periti industriali e periti industriali laureati (EPPI)' },
  { value: TipoCassa.EPAP, label: 'Ente previdenza e assistenza pluricategoriale (EPAP)' },
  { value: TipoCassa.ENPAB, label: 'Ente nazionale previdenza e assistenza biologi (ENPAB)' },
  { value: TipoCassa.ENPAPI, label: 'Ente Nazionale Previdenza e Assistenza Professione. Infermieristica (ENPAPI).' },
  { value: TipoCassa.ENPAP, label: 'Ente nazionale previdenza e assistenza psicologi (ENPAP)' },
  { value: TipoCassa.INPS, label: 'INPS' },
];

export const valueToSocialSecurityEinvoice = (
  values: DocumentBuilderForm,
  vatTotals: VatTotal[],
): DatiCassaPrevidenziale[] => {
  if (!values.socialSecurity) {
    return [];
  }

  const highestVatItem = vatTotals.sort((a, b) => {
    return BigNumber(b.vatPercentage).comparedTo(BigNumber(a.vatPercentage)) || 0;
  })[0]!;

  const taxableAmount = BigNumber(values.socialSecurity.taxableAmount);
  const socialSecurityPercentage = BigNumber(values.socialSecurity.percentage);

  return [
    {
      tipoCassa: values.socialSecurity.type,
      alCassa: socialSecurityPercentage.toFixed(),
      aliquotaIva: BigNumber(highestVatItem.vatPercentage).decimalPlaces(2).toFixed(2),
      natura: highestVatItem.vatExemption,
      importoContributoCassa: taxableAmount
        .multipliedBy(socialSecurityPercentage)
        .dividedBy(100)
        .decimalPlaces(2)
        .toFixed(),
      imponibileCassa: taxableAmount.decimalPlaces(2).toFixed(),
      riferimentoAmministrazione: null,
      ritenuta: null,
    },
  ];
};
